<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> DSS Settlement Account: 02320750011234 </span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Book Balance: USD {{accountDetails['availableBalance']}}</span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="accountTransactions"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
<!--              <template v-slot:[`item.actions`]="{ item }">-->
<!--                <v-menu offset-y>-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-btn-->
<!--                      color="primary"-->
<!--                      dark-->
<!--                      v-on="on"-->
<!--                      text-->
<!--                      icon-->
<!--                      class="actions"-->
<!--                    >-->
<!--                      <v-icon> more_horiz </v-icon>-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <v-list>-->
<!--                    <v-list-item @click="openTransactionEnquiryDialog(item)">-->
<!--                      <v-list-item-title > Enquiry </v-list-item-title>-->
<!--                    </v-list-item>-->
<!--                  </v-list>-->
<!--                </v-menu>-->
<!--              </template>-->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
    <v-dialog v-model="transactionEnquiryDialog"  max-width="1000px" >
      <v-card>
        <v-card-title>
          <span class="headline">Transaction Enquiry</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers2"
                    :items="accountTransactionDetails"
                    :items-per-page="5"
                    :search="search"
                    class="elevation-1"
                  ></v-data-table>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			transactionEnquiryDialog: false,
			accountDetails: {},
			accountTransactions: [],
			accountTransactionDetails: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Transaction ID', value: 'transactionID' },
				{ text: 'Transaction Reference', value: 'transactionReference' },
				{ text: 'Transaction Amount', value: 'transactionAmount' },
				{ text: 'Running Balance', value: 'runningBalance' },
				{ text: 'Transaction Date', value: 'transactionDate' },
				{ text: 'Narration', value: 'narration' },
				{ text: 'DR/CR', value: 'debitCreditFlag' }
				// { text: 'Actions', value: 'actions', sortable: false }
			],
			headers2: [
				{ text: 'Account Number', value: 'cccountNumber' },
				{ text: 'Transaction Reference', value: 'transactionReference' },
				{ text: 'Transaction Amount', value: 'amount' },
				{ text: 'ExchangeRate', value: 'exchangeRate' },
				{ text: 'Transaction Date', value: 'transactionDate' },
				{ text: 'ResponseDescription', value: 'responseDescription' },
				{ text: 'Narration', value: 'narration' }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null
		}
	},
	mounted () {
		this.getAccountReport()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		openTransactionEnquiryDialog (item) {
			console.log(item)
			console.log(item.transactionID)
			console.log(item.transactionDate)
			this.transactionEnquiryDialog = true
			this.getAccountTransactionDetails(item.transactionID, item.transactionDate)
		},
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getAccountReport () {
			http.get(config.serverURI + '/miller/findAccountReport')
				.then(response => {
					this.accountDetails = response.data
					console.log('accountDetails -> ', response.data)
					this.getAccountTransactions()
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getAccountTransactions () {
			http.get(config.serverURI + '/miller/findAccountTransactions')
				.then(response => {
					console.log('accountTransactions -> ', response.data)
					const items = response.data
					items.forEach(item => {
						item.amount = this.truncateDecimal(item.amount)
					})
					this.accountTransactions = items
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response ? error.response.data.message : 'Error ocurred'
					}, { root: true })
				})
		},
		getAccountTransactionDetails (transactionId, date) {
			http.get(config.serverURI + '/miller/findAccountTransactionDetails?transactionId=' + transactionId + '&date=' + date)
				.then(response => {
					console.log('getAccountTransactionDetails -> ', response.data)
					this.accountTransactionDetails = response.data
					// this.accountTransactions = response.data
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response ? error.response.data.message : 'Error ocurred'
					}, { root: true })
				})
		},
		exportToExcel () {
			const exportData = this.accountTransactions.map(transaction => ({
				'Transaction ID': transaction.transactionID,
				'Transaction Reference': transaction.transactionReference,
				'Transaction Amount': transaction.transactionAmount,
				'Running Balance': transaction.runningBalance,
				'Transaction Date': transaction.transactionDate,
				Narration: transaction.narration,
				'DR/CR': transaction.debitCreditFlag
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'accountData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'dss_account_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		truncateDecimal (value) {
			if (!isNaN(value)) {
				// Check if the number is a whole number
				if (Number.isInteger(value)) {
					return value.toString() // Return as a string to avoid displaying trailing .00
				} else {
					return parseFloat(value).toFixed(2) // Truncate to 2 decimal places
				}
			}
			return value
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}

.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn {
  padding: 10px;
  margin: 5px;
}

.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col {
  border: 1px solid brown;
}
</style>
